import script from "./UserFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserFooter.vue?vue&type=script&setup=true&lang=ts"

import "./UserFooter.vue?vue&type=style&index=0&id=c5be7608&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5be7608"]])

export default __exports__